import { apiCall, apiCallAdmin } from "../services/api-service";

export const getOrgLogoApi = async () => {
  const response = await apiCallAdmin("get", "get_org_image");
  return response?.data;
};

export const getProfileDetailsApi = async () => {
  const response = await apiCallAdmin("get", "basicprofile");
  return response;
};

export const getCountDetApi = async () => {
  return apiCall("get", "dashboard/count_details");
};
export const getRecentCommentApi = async () => {
  return apiCall("get", "dashboard/recent_comments");
};

export const getFuelCostApi = async (bodyData) => {
  return apiCall("post", "dashboard/fuel_cost", bodyData);
};
export const getServiceCostApi = async (bodyData) => {
  return apiCall("post", "dashboard/service_cost", bodyData);
};
export const getOtherCostApi = async (bodyData) => {
  return apiCall("post", "dashboard/other_cost", bodyData);
};
export const getKmCostApi = async (bodyData) => {
  return apiCall("post", "dashboard/km_cost", bodyData);
};
export const getLiveMapApi = async (bodyData) => {
  return apiCall("post", "get_trackings", bodyData);
};
export const getLiveViewApi = async () => {
  return apiCall("get", "dashboard/live_view");
};

export const reportAnIssueApi = async (data) => {
  return apiCallAdmin("post", "report_issue", data);
};

export const getReportIssueTypeApi = async () => {
  const response = await apiCallAdmin("get", "get_issue_type");
  return response?.data;
};

export const getFAQListApi = async () => {
  const response = await apiCallAdmin("get", "help?application=Vehicle Management");
  return response?.data;
};
